import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/monitoring'
  },
  {
    path: '/',
    redirect: '/monitoring'
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import('@/views/monitoring.vue'),
    meta: {
      title: '监控'
    }
  },
  {
    path: '/gwtMonitoring',
    name: 'gwtMonitoring',
    component: () => import('@/views/gwtMonitoring.vue'),
    meta: {
      title: '天通监控'
    }
  },
  {
    path: '/intercom',
    name: 'intercom',
    component: () => import('@/views/intercom.vue'),
    meta: {
      title: '对讲'
    }
  },
  {
    path: '/trajectory',
    name: 'trajectory',
    component: () => import('@/views/trajectory.vue'),
    meta: {
      title: '轨迹'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
